<template>
  <draggable v-model="contactChannelOptions" tag="tbody" @end="onDragEnd">
    <tr v-for="(item, index) in contactChannelOptions" :key="index">
      <td><fluent-icon icon="drag" /></td>
      <td>
        <woot-switch
          :value="item['enabled']"
          @input="handleContactChannelsOptions($event, 'enabled', item)"
        />
      </td>
      <td :class="{ 'disabled-text': !item['enabled'] }">
        <input
          v-model.trim="item.title"
          type="text"
          class="m-0"
          :disabled="isFieldEditable(item)"
        />
      </td>
      <td :class="{ 'disabled-text': !item['enabled'] }">
        <input
          v-model.trim="item.value"
          type="text"
          class="m-0"
          :disabled="isFieldEditable(item)"
          :placeholder="item.input_placeholder"
        />
      </td>
      <td class="w-2/5" :class="{ 'disabled-text': !item['enabled'] }">
        <input
          v-if="item.default_text !== ''"
          v-model.trim="item.display_text"
          type="text"
          class="w-content m-0"
          :disabled="isFieldEditable(item)"
          :placeholder="item.default_text"
        />
        <!-- {{ displayText(item) }} -->
      </td>
    </tr>
  </draggable>
</template>

<script>
import draggable from 'vuedraggable';
export default {
  components: { draggable },
  props: {
    contactChannels: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      contactChannelOptions: this.contactChannels,
    };
  },
  watch: {
    contactChannels() {
      this.contactChannelOptions = this.contactChannels;
    },
  },
  methods: {
    isFieldEditable(item) {
      return !item.enabled;
    },
    handleContactChannelsOptions(event, type, item) {
      this.$emit('update', event, type, item);
    },
    onDragEnd() {
      this.$emit('drag-end', this.contactChannelOptions);
    },
    displayText(item) {
      return item.value
        ? item.default_text.replace('{{input_value}}', item.value)
        : item.default_text;
    },
  },
};
</script>
